import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import LogoMark from '../components/LogoMark';

const NAV = [
  { to:'/admin',          icon:'M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6', label:'Дашборд',  end:true  },
  { to:'/admin/orders',   icon:'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2', label:'Заявки'           },
  { to:'/admin/services', icon:'M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z', label:'Услуги'           },
  { to:'/admin/pricing',  icon:'M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z', label:'Тарифы'           },
  { to:'/admin/contacts', icon:'M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z', label:'Контакты'         },
  { to:'/admin/settings', icon:'M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z M15 12a3 3 0 11-6 0 3 3 0 016 0z', label:'Настройки'        },
];

function Icon({ path }) {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      {path.split(' M').map((p,i) => <path key={i} d={i===0?p:'M'+p}/>)}
    </svg>
  );
}

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const handleLogout = () => { logout(); nav('/admin/login'); };

  return (
    <div style={{ display:'flex', minHeight:'100vh', background:'#F5F7FA', fontFamily:"'Golos Text',sans-serif" }}>
      {/* Sidebar */}
      <aside style={{ width:220, minWidth:220, background:'#fff', display:'flex', flexDirection:'column', borderRight:'1px solid #F0F0F0', position:'sticky', top:0, height:'100vh', overflowY:'auto' }}>
        {/* Logo */}
        <div style={{ padding:'20px 18px 16px', borderBottom:'1px solid #F5F5F5' }}>
          <div style={{ display:'flex', alignItems:'center', gap:10 }}>
            <LogoMark size={34} />
            <div>
              <div style={{ fontFamily:"'Unbounded',sans-serif", fontWeight:800, fontSize:'0.82rem', color:'#06101e', lineHeight:1.2 }}>MasterClean<span style={{ color:'#00C2B8' }}>Pro</span></div>
              <div style={{ fontSize:'0.68rem', color:'#9CA3AF', marginTop:1 }}>Панель управления</div>
            </div>
          </div>
        </div>

        {/* Nav */}
        <nav style={{ flex:1, padding:'10px 10px' }}>
          <div style={{ fontSize:'0.65rem', fontWeight:700, color:'#D1D5DB', letterSpacing:'0.08em', textTransform:'uppercase', padding:'8px 8px 4px' }}>Меню</div>
          {NAV.map(({ to, icon, label, end }) => (
            <NavLink key={to} to={to} end={end} style={({ isActive }) => ({
              display:'flex', alignItems:'center', gap:10, padding:'9px 10px', borderRadius:10, textDecoration:'none', fontSize:'0.875rem', fontWeight: isActive ? 700 : 500,
              color: isActive ? '#00C2B8' : '#6B7280',
              background: isActive ? 'rgba(0,194,184,0.08)' : 'transparent',
              marginBottom:2, transition:'all .15s'
            })}>
              <Icon path={icon}/>
              {label}
            </NavLink>
          ))}
        </nav>

        {/* User */}
        <div style={{ padding:'12px 14px', borderTop:'1px solid #F5F5F5' }}>
          <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:10 }}>
            <div style={{ width:32, height:32, borderRadius:'50%', background:'#F0FFFE', border:'2px solid #00C2B8', display:'grid', placeItems:'center', fontFamily:"'Unbounded',sans-serif", fontWeight:800, fontSize:'0.75rem', color:'#00C2B8', flexShrink:0 }}>A</div>
            <div>
              <div style={{ fontSize:'0.82rem', fontWeight:700, color:'#111' }}>{user}</div>
              <div style={{ fontSize:'0.68rem', color:'#9CA3AF' }}>Администратор</div>
            </div>
          </div>
          <button onClick={handleLogout} style={{ width:'100%', padding:'8px', background:'#FEF2F2', color:'#EF4444', border:'none', borderRadius:8, fontSize:'0.8rem', fontWeight:700, cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', gap:6 }}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9"/></svg>
            Выйти
          </button>
        </div>
      </aside>

      {/* Main */}
      <main style={{ flex:1, padding:'28px 32px', overflowY:'auto', minWidth:0 }}>
        <Outlet/>
      </main>
    </div>
  );
}
